import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

// Keeps the UI language and the account's saved language preference (users.lang) in sync.
export function LangSync() {
  const { user, setUser } = useAuth();
  const { lang, setLang } = useLang();
  const synced = useRef(null);
  const uid = user?.user_id || null;
  const saved = user?.lang;

  const save = (l) => api.put("/auth/lang", { lang: l }).then(() => setUser((u) => (u ? { ...u, lang: l } : u))).catch(() => {});

  useEffect(() => {
    if (!uid) { synced.current = null; return; }
    if (saved === undefined) return;
    if (synced.current !== uid) {
      synced.current = uid;
      if (saved === "ar" || saved === "en") { if (saved !== lang) setLang(saved); } else save(lang);
    } else if ((saved === "ar" || saved === "en") && saved !== lang) setLang(saved);
  }, [uid, saved]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (uid && synced.current === uid && saved !== lang) save(lang);
  }, [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
